// GA4 + Meta Pixel — single routing-owned page-view system (no double counting).
// IDs come from env; everything is a no-op until they're set.
const GA_ID = (process.env.REACT_APP_GA4_ID || "").trim();
const META_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();

export const isReactSnap =
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

const canTrack = typeof window !== "undefined" && !isReactSnap;
const trackedPageKeys = new Set();
let initialized = false;

function appendScript(id, src) {
  if (document.getElementById(id)) return;
  const script = document.createElement("script");
  script.id = id;
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

export function initAnalytics() {
  if (!canTrack || initialized) return;
  initialized = true;

  if (GA_ID) {
    window.dataLayer = window.dataLayer || [];
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
    appendScript("ga4-gtag", `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`);
  }

  if (META_ID) {
    if (!window.fbq) {
      const fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      fbq.disablePushState = true;
      window.fbq = fbq;
    }
    window.fbq.disablePushState = true;
    window.fbq("init", META_ID);
    appendScript("meta-pixel", "https://connect.facebook.net/en_US/fbevents.js");
  }

  // Delegated primary-CTA click tracking (every "Start My Health Assessment" link).
  document.addEventListener("click", (e) => {
    const link = e.target.closest && e.target.closest('a[href="/get-started"], a[href$="/get-started"]');
    if (link) {
      trackEvent("assessment_cta_click", {
        placement: window.location.pathname,
        cta_testid: link.getAttribute("data-testid") || "unknown",
      });
    }
  });
}

function pageKey(location) {
  return location.key || `${location.pathname}${location.search}${location.hash}`;
}

export function trackPageView(location) {
  if (!canTrack) return;
  const key = pageKey(location);
  if (trackedPageKeys.has(key)) return;
  trackedPageKeys.add(key);

  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}${location.hash}`,
    });
  }
  if (META_ID && window.fbq) {
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (!canTrack) return;
  if (GA_ID && window.gtag) window.gtag("event", name, params);
  if (META_ID && window.fbq) window.fbq("trackCustom", name, params);
}

export const analytics = {
  formStarted: (params) => trackEvent("form_started", params),
  leadSubmitted: (params) => trackEvent("lead_submitted", params),
};
